import React from 'react';
import EntityModal, { EntityConfig } from '../ui/EntityModal';

interface FileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (fileData: { name: string }) => Promise<void>;
  initialData?: { name: string };
}

const fileConfig: EntityConfig = {
  entityName: 'file',
  titles: {
    edit: 'Edit File Name',
  },
  description: {
    edit: 'Update the display name for this audio file',
  },
  fieldLabel: 'File Name',
  placeholder: 'Enter file name',
  helperText: 'Maximum 255 characters. This will be used as the display name.',
  validation: (name: string) => {
    if (name.length > 255) {
      return 'File name must be 255 characters or less';
    }
    return null;
  },
};

const FileModal: React.FC<FileModalProps> = (props) => {
  return <EntityModal {...props} mode="edit" config={fileConfig} />;
};

export default FileModal;
